export default __webpack_public_path__ + "static/media/default-user.9306e126.png";